var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConnectionSent = function SvgConnectionSent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7575 10.2423L16.4929 1.50692M7.86364 10.5152L10.0501 16.1375C10.2427 16.6328 10.339 16.8804 10.4778 16.9527C10.5981 17.0154 10.7414 17.0155 10.8617 16.953C11.0006 16.8808 11.0972 16.6333 11.2904 16.1382L16.7732 2.08862C16.9476 1.64171 17.0348 1.41826 16.9871 1.27548C16.9456 1.15148 16.8483 1.05417 16.7243 1.01274C16.5816 0.965044 16.3581 1.05224 15.9112 1.22664L1.86158 6.70942C1.36651 6.90262 1.11898 6.99922 1.04684 7.13807C0.984306 7.25845 0.984391 7.40175 1.04707 7.52205C1.11937 7.66082 1.36701 7.75712 1.86231 7.94974L7.48457 10.1362C7.58511 10.1753 7.63538 10.1948 7.67771 10.225C7.71523 10.2518 7.74804 10.2846 7.7748 10.3221C7.805 10.3644 7.82455 10.4147 7.86364 10.5152Z",
    stroke: "#3481DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnectionSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connectionSent.5222b8aa.svg";
export { ForwardRef as ReactComponent };